import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Activity, Key, TrendingUp } from 'lucide-react';
const features = [{
  icon: ShieldCheck,
  title: 'Validación Radical',
  description: 'Entiende por qué tu duelo es legítimo y cómo dejar de invalidarte.'
}, {
  icon: Activity,
  title: 'Neurociencia del Desapego',
  description: 'Descubre qué pasa en tu cerebro y cómo romper el bucle de la rumiación constante.'
}, {
  icon: Key,
  title: 'Herramientas de Cierre',
  description: 'Rituales prácticos para darle a tu mente la conclusión que la otra persona no supo darte.'
}, {
  icon: TrendingUp,
  title: 'El Upgrade',
  description: 'Estrategias para elevar tu "valor relacional" y atraer conexiones basadas en la claridad, no en la carencia.'
}];
export function Features() {
  return <section className="py-24 md:py-32 bg-dark-800 relative" data-id="element-43">
      <div className="container mx-auto px-6" data-id="element-44">
        <div className="max-w-3xl mb-20" data-id="element-45">
          <motion.span className="text-brand-muted tracking-widest uppercase text-sm font-medium mb-4 block" initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-46">
            ¿Qué vas a encontrar dentro del Ebook?
          </motion.span>
          <motion.h2 className="text-5xl md:text-7xl leading-[0.9]" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-47">
            TU MAPA DE RUTA DEL VACÍO A LA{' '}
            <span className="text-brand-muted" data-id="element-48">ABUNDANCIA.</span>
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl" data-id="element-49">
          {features.map((feature, index) => <motion.div key={index} className="group p-8 rounded-2xl bg-dark-900 border border-dark-700 hover:border-dark-500 transition-all duration-300" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-50">
              <div className="flex items-start gap-6" data-id="element-51">
                <div className="w-12 h-12 shrink-0 rounded-full bg-dark-800 flex items-center justify-center text-brand-light group-hover:scale-110 transition-transform duration-300" data-id="element-52">
                  <feature.icon className="w-5 h-5" data-id="element-53" />
                </div>
                <div data-id="element-54">
                  <h3 className="text-2xl font-heading tracking-wide mb-2" data-id="element-55">
                    {feature.title}
                  </h3>
                  <p className="text-brand-muted leading-relaxed font-light" data-id="element-56">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}